var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useEffect, useRef, useState } from 'react';
export const useIsMounted = () => {
    const isMounted = useRef(true);
    useEffect(() => () => {
        isMounted.current = false;
    }, []);
    return isMounted;
};
export const useAsync = (cb, deps = [], delayCall = false) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const callBack = useCallback((args) => cb(args), [...deps, cb]);
    const isMountedRef = useIsMounted();
    const fetchData = useCallback((...args) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        setLoading(true);
        try {
            const result = yield callBack(args);
            if (!isMountedRef.current)
                return;
            setData(result);
        }
        catch (error) {
            if (!isMountedRef.current)
                return;
            if (error instanceof Error) {
                setError(error);
                return;
            }
            setError(new Error(((_a = error) === null || _a === void 0 ? void 0 : _a.message) || 'Unknown error'));
        }
        finally {
            if (isMountedRef.current) {
                setLoading(false);
            }
        }
    }), [callBack, isMountedRef]);
    const fetchDataRef = useRef(fetchData);
    useEffect(() => {
        fetchDataRef.current = fetchData;
    }, [fetchData]);
    useEffect(() => {
        if (!delayCall) {
            fetchDataRef.current();
        }
    }, [delayCall]);
    return { loading, data, error, call: fetchData };
};
//# sourceMappingURL=useAsync.js.map